import { render, staticRenderFns } from "./X.svg.vue?vue&type=template&id=370d386d"
import script from "./X.svg.vue?vue&type=script&lang=ts"
export * from "./X.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('370d386d')) {
      api.createRecord('370d386d', component.options)
    } else {
      api.reload('370d386d', component.options)
    }
    module.hot.accept("./X.svg.vue?vue&type=template&id=370d386d", function () {
      api.rerender('370d386d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/common/X.svg.vue"
export default component.exports